import { IconPropsType } from "../../types";

const Tick = (props: IconPropsType) => {
  return (
    <div className="flex items-center justify-center">
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke="currentColor"
        className={props.additionalStyle}
      >
        <path
          d="M5.5 12L10.5 17L20.5 7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default Tick;
